goog.provide("shadow.js.shim.module$ol$interaction");
goog.provide("module$shadow_js_shim_module$ol$interaction");
shadow.js.shim.module$ol$interaction = shadow.js.nativeProvides["ol/interaction"] = shadow$bridge("ol/interaction");
module$shadow_js_shim_module$ol$interaction.default = shadow.js.shim.module$ol$interaction;
